import { useRouter } from 'next/router';
import {
  Select, MenuItem, Checkbox, FormControl, InputLabel, Button,
} from '@mui/material';
import { updateRouterQuery } from 'lib/utils/filterUtils';
import { castArray } from 'lodash';
import { jobTypes } from 'lib/constants/jobs';
import { JobType } from 'lib/types/jobs';

interface Props {
  selected?: string[];
}

export const JobTypeFilter = ({
  selected = [],
}: Props) => {
  const router = useRouter();
  const allTypes = Object.keys(jobTypes);
  const values = selected.length === 0 ? allTypes : castArray(selected);

  const onChange = (n: string[]) => {
    updateRouterQuery(router, { jobTypes: n });
  };

  const onClose = (): void => {
    // This is a small hack so that the Select blurs when the select menu is closed.
    // See https://stackoverflow.com/questions/65411927/blur-material-ui-select-component-on-the-onchange-event
    setTimeout(() => {
      (document?.activeElement as HTMLInputElement)?.blur();
    }, 0);
  };

  return (
    <FormControl className="w-full" size="small">
      <InputLabel id="jobType">Job Types</InputLabel>
      <Select
        className="w-full"
        label="job types"
        labelId="jobType"
        id="jobType"
        multiple
        onClose={onClose}
        onChange={(e) => onChange(e.target.value as string[])}
        renderValue={(v) => (v.length === allTypes.length ? 'All' : v.map((s) => jobTypes[s as JobType]).join(', '))}
        value={values}
      >
        {allTypes.map(
          (key: string) => (
            <MenuItem key={key} value={key}>
              <div className="flex flex-1 items-center justify-between group">
                <div>
                  <Checkbox size="small" checked={selected.length === 0 || selected.includes(key)} />
                  {jobTypes[key as JobType]}
                </div>
                <div className="hidden group-hover:block">
                  <Button
                    size="small"
                    onClick={(e) => {
                      onChange([key]);
                      e.stopPropagation();
                    }}
                  >
                    Only
                  </Button>
                </div>
              </div>
            </MenuItem>
          ),
        )}
        <div className="text-right pr-2">
          <Button
            type="button"
            size="small"
            onClick={() => onChange([])}
            disabled={values.length === allTypes.length}
          >
            Clear

          </Button>
        </div>
      </Select>
    </FormControl>
  );
};
